import { FilterField, labelId } from "kontrolEdge/helpers/advancedFilters";
import { LogItem } from "./LogsData";

export function makeLogFields(): FilterField<LogItem>[] {
  const fields: FilterField<LogItem>[] = [
    {
      label: "Timestamp",
      key: "timestamp",
      accessor: (r) => r.timestamp,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Severity Level",
      key: "severitylevel",
      accessor: (r) => r.level,
      type: "string",
      inFreeText: true,
    },
    {
      label: "Message",
      key: "message",
      accessor: (r) => r.message,
      type: "string",
      inFreeText: true,
    },
  ];

  // Ensure keys are set
  for (const f of fields) f.key ||= labelId(f.label);
  return fields;
}

